import React, { useRef } from "react";
import { openConfirmAlert } from "@ctsu/react-ctsu-ui";

import { putWithAuth } from "protocol-setup/redux/makeFetch";
import { FasTrashAlt } from "assets/icons";
import { useHistory } from "react-router-dom";
import {
  defaultErrorMessage,
  statusUpdateUrl
} from "protocol-setup/redux/constants";
import {
  OpenErrorNotification
} from "../notification";

const DeleteRequest = ({
  requestId,
  item,
  index,
  getIcon,
  protocolNumber,
  requestStatus = "Draft",
  disabled
}) => {

  const history = useRef(useHistory());
  const buttonRef = useRef(null);
  const handleClick = () => {
    openConfirmAlert({
      title: (
        <div className="d-flex align-items-center">
          <FasTrashAlt className="mr-2 color-red" />
          <span>Delete Request</span>
        </div>
      ),
      message: (
        <div>
          <p>
            Please confirm you would like to delete{" "}
            {protocolNumber ? `${protocolNumber}` : ""} Request {requestId} in{" "}
            {requestStatus}-status and lose all request data.
          </p>
          <p>
            If you would like to continue editing this request, please Cancel.
          </p>
        </div>
      ),
      buttons: [
        {
          label: "Confirm",
          onClick: async () => {
            try {
              // Delete the request by setting status to INACTIVE
              await putWithAuth(statusUpdateUrl, {
                requestNumber: requestId,
                requestStatus: "INACTIVE"
              });
              history.current.push("/protocol-setup/browser", {
                showSuccessMessage: true,
                message: "Record successfully deleted."
              });
            } catch (error) {
              OpenErrorNotification({
                message: error?.message || defaultErrorMessage
              });
            }
          },
          className: ""
        },
        {
          label: "Cancel",
          onClick: () => {if (buttonRef.current) {
              setTimeout(() => {
                buttonRef.current.focus();
              }, 0);
            } },
          className: "close"
        }
      ]
    });
  };

  if (item?.disabled) {
    return null;
  }

  return (
    <button
      ref={buttonRef}
      key={`${item.requestNumber}_${index}`}
      type="button"
      disabled={item.disabled || disabled}
      onClick={handleClick}
      className="btn mx-1 summary-bar-item"
    >
      {item.displayBefore && (
        <span
          data-requestnumber={`${item.requestNumber}-summary-${item.key}`}
          className="summary-bar-key"
        >
          {getIcon(item.icon)}
        </span>
      )}
      <span
        data-requestnumber={`${item.requestNumber}-summary-${item.value.split(" ")[0]
          }`}
        className="summary-bar-value"
      >
        {item.value}
      </span>
      {!item.displayBefore && (
        <span
          data-requestnumber={`${item.requestNumber}-summary-${item.key}`}
          className="summary-bar-key"
        >
          {getIcon(item.icon)}
        </span>
      )}
    </button>
  );
};

export default DeleteRequest;
